import React from "react";
import MetricTableRowOld from "MetricTableRowOld";
import Table from "react-bootstrap/Table";
import { startCase, camelCase } from "lodash";
import jsDig from "utils/jsDig";

class MetricTableOld extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      table: props.table,
      date: moment(props.date),
      headerOrder: this.props.headerOrder,
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps.table !== this.props.table) {
      this.setState({
        table: this.props.table,
      });
    }
  }
  render() {
    if (!this.props.table) return <div>No Data To Display Yet!</div>;
    let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    let scrollMesage = <div></div>;

    if (this.props.scrollMessage) {
      scrollMesage = <div className="table-caption small text-center font-italic d-none">Scroll right to view entire chart</div>;
    }

    return (
      <React.Fragment>
        <div
          className={this.props.responsive ? "table-responsive" : ""}
          style={{ margin: "auto", width: this.props.headerOrder.length > 2 ? "inherit" : "50%" }}>
          <Table className="mt-2 table-white table-striped metric-table">
            <thead>
              <tr>
                <th scope="col" colSpan="1" className="yy-table-header" style={{ border: "none" }}></th>
                {this.state.headerOrder.map((metricName) => {
                  let metricTitle = _.startCase(_.camelCase(metricName));

                  if (metricTitle.includes("Roas")) {
                    metricTitle = metricTitle.slice(0, -4) + metricTitle.slice(-4).toUpperCase();
                  }
                  if (metricTitle.includes("Aov")) {
                    metricTitle = metricTitle.slice(0, -3) + metricTitle.slice(-3).toUpperCase();
                  }

                  if (metricTitle.includes("Cpa")) {
                    metricTitle = metricTitle.slice(0, -3) + metricTitle.slice(-3).toUpperCase();
                  }
                  if (metricTitle.includes("Cvr")) {
                    metricTitle = "Conv. Rate";
                  }
                  if (metricTitle === "Traffic") {
                    metricTitle = "Organic Traffic";
                  }

                  return (
                    <th key={metricName} scope="col" colSpan="3" className="bg-transparent" style={{ border: "none" }}>
                      <div className="d-flex justify-content-center">{metricTitle}</div>
                    </th>
                  );
                })}
              </tr>
              <tr className="dates bg-transparent">
                <th className="bg-transparent" style={{ border: "none" }}></th>
                {this.state.headerOrder.map((metricName) => {
                  return (
                    <React.Fragment key={metricName}>
                      <th scope="col" className="bg-white" style={{ border: "2px solid #2c345b " }}>
                        {this.props.date ? (
                          parseInt(this.props.date.substring(0, 4)) - 1
                        ) : (
                          "No date"
                        )}
                      </th>
                      <th scope="col" className="bg-white" style={{ border: "2px solid #2c345b " }}>
                        {" "}
                        {this.state.date.year()}{" "}
                      </th>
                      <th scope="col" className="bg-white" style={{ border: "2px solid #2c345b " }}>
                        Y/Y
                      </th>
                    </React.Fragment>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((num) => {
                return (
                  <tr key={num}>
                    <th className={(num % 3 != 0 ? "no-border-tb" : "no-border-t") + " text-left"} scope="row">
                      {months[num - 1]}
                    </th>
                    {this.state.headerOrder.map((metricName) => {
                      return (
                        <MetricTableRowOld
                          key={metricName}
                          metricName={metricName}
                          rowNumber={num}
                          thisYearValue={jsDig([metricName, this.state.date.year().toString(), num.toString()], this.state.table)}
                          lastYearValue={jsDig([metricName, (this.state.date.year() - 1).toString(), num.toString()], this.state.table)}
                        />
                      );
                    })}
                  </tr>
                );
              })}
              <tr style={{ backgroundColor: "#e0e4ef" }}>
                <th className="no-border-tb text-left" scope="row">
                  YTD
                </th>
                {this.state.headerOrder.map((metricName) => {
                  return (
                    <MetricTableRowOld
                      key={metricName}
                      metricName={metricName}
                      rowNumber={13}
                      thisYearValue={jsDig([metricName, this.state.date.year().toString(), "ytd"], this.state.table)}
                      lastYearValue={jsDig([metricName, (this.state.date.year() - 1).toString(), "ytd"], this.state.table)}
                    />
                  );
                })}
              </tr>
              <tr style={{ backgroundColor: "#e0e4ef" }}>
                <th className="no-border-t text-left" scope="row">
                  Total
                </th>
                {this.state.headerOrder.map((metricName) => {
                  return (
                    <MetricTableRowOld
                      key={metricName}
                      metricName={metricName}
                      rowNumber={14}
                      thisYearValue={jsDig([metricName, this.state.date.year().toString(), "total"], this.state.table)}
                      lastYearValue={jsDig([metricName, (this.state.date.year() - 1).toString(), "total"], this.state.table)}
                      bottomRow={true}
                    />
                  );
                })}
              </tr>
            </tbody>
          </Table>
        </div>
        {scrollMesage}
      </React.Fragment>
    );
  }
}
export default MetricTableOld;
